import * as React from 'react';
import { c } from '../../../utils/tailwind-merge';
import { usePopoverContext } from './Popover.context';

export const PopoverTrigger = React.forwardRef<
  HTMLButtonElement,
  React.ButtonHTMLAttributes<HTMLButtonElement> & { className?: string }
>(({ children, className, ...props }, forwardedRef) => {
  const { refs, getReferenceProps, open, id } = usePopoverContext();

  const setRef = React.useCallback(
    (node: HTMLButtonElement | null) => {
      refs.setReference(node as HTMLElement | null);
      if (!forwardedRef) return;
      if (typeof forwardedRef === 'function')
        forwardedRef(node as HTMLButtonElement | null);
      else
        (
          forwardedRef as React.MutableRefObject<HTMLButtonElement | null>
        ).current = node as HTMLButtonElement | null;
    },
    [refs, forwardedRef]
  );

  return (
    <button
      {...getReferenceProps({
        ref: setRef,
        ...props,
      })}
      className={c(
        'cursor-pointer border-none bg-transparent p-0',
        className || ''
      )}
      aria-controls={id}
      aria-expanded={open}
      type="button"
    >
      {children}
    </button>
  );
});
PopoverTrigger.displayName = 'PopoverTrigger';
